export default "__VITE_ASSET__18c90af2__"